import { PageId, PricePresentationProps, PricePresentationType, PriceProperties } from '@vp/price-platform'

export const getPricePresentationConfig = (
  pageId: PageId,
  priceProperties: PriceProperties,
  type: PricePresentationType,
  { totalDiscountedPrice, totalListPrice, unitDiscountedPrice, unitListPrice }: Gallery.Pricing.Prices,
): PricePresentationProps | null => {
  const updatedPriceProperties = { ...priceProperties, quantity: priceProperties.quantity || 0 }

  switch (type) {
    case PricePresentationType.QtyFromPrice:
      return {
        pageId,
        priceProperties: updatedPriceProperties,
        /* For the price--platform A / B test regarding Elev8 price variation,
          we need to paas presentation type as "QtyForPrice" at the place of "QtyFromPrice"
          and as the price presentation type("QtyFromPrice") comes from GMT, we can't change it directly,
          so modifying it here and later we might change it globally if the test succeeds. */
        presentationType: PricePresentationType.QtyForPrice,
        prices: {
          totalDiscountedPrice,
          totalListPrice,
          unitListPrice,
          unitDiscountedPrice,
        },
      }
    case PricePresentationType.AsLowAsPricePerPiece:
      return {
        pageId,
        priceProperties: updatedPriceProperties,
        presentationType: PricePresentationType.AsLowAsPricePerPiece,
        prices: { unitListPrice, unitDiscountedPrice },
      }
    case PricePresentationType.QtyStartingAtPrice:
      return {
        pageId,
        priceProperties: updatedPriceProperties,
        presentationType: PricePresentationType.QtyStartingAtPrice,
        prices: {
          totalListPrice,
          totalDiscountedPrice,
        },
      }
    default:
      return null
  }
}
